import React, { useEffect } from "react";
import useCalendarSale from "./hooks/useCalendarSale";
import "./style.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";
import useFacility from "../../../utils/hooks/useFacility";
import MainBannerTours from "./mainBannerTours";
import EAPageHeader from "../shared/EAPageHeader";
import EAPageMessage from "../shared/EAPageMessage";

const TourSale: React.FC = () => {
  const { getExercisesAvailable, exerciseAvailAble } = useCalendarSale();
  const saleConfiguration = useSelector((state: State) => state.config.configuration);
  const facilityIds = useFacility();
  useEffect(() => {
    getExercisesAvailable();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityIds]);

  return (
    <div>
      <EAPageHeader title="Trasy koncertowe" />
      <EAPageMessage message={saleConfiguration.message_stepByStep} />

      {exerciseAvailAble && (
        <div className="exercise-available-wrapper">
          {exerciseAvailAble.map((item, index) => (
            <>
              <MainBannerTours exercise={item} key={index} />
            </>
          ))}
        </div>
      )}
    </div>
  );
};

export default TourSale;
